import React from "react";
import ecommerceIcon from "../../common/images/cus-v-5.png";
import healthcareIcon from "../../common/images/cus-v-4.png";
import financeIcon from "../../common/images/cus-v-6.png";
import logisticsIcon from "../../common/images/cus-v-3.png";
import parkingIcon from "../../common/images/cus-v-2.png";
import retailIcon from "../../common/images/cus-v-1.png";

const industries = [
  { name: "E-commerce", icon: ecommerceIcon },
  { name: "Healthcare", icon: healthcareIcon },
  { name: "Finance", icon: financeIcon },
  { name: "Logistics", icon: logisticsIcon },
  { name: "Airport Parking", icon: parkingIcon },
  { name: "Retail", icon: retailIcon },
];

export default function IndustriesSection() {
  return (
    <section className="md:px-10 px-5 py-7 text-center bg-gradient-to-b from-[#EFF5F9] to-white">
     <div className="text-center mb-10">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900">
        Industries We Serve        </h2>
        <div className="underline md:w-1/5 w-2/5 flex justify-center mx-auto my-4 items-center h-[2px] rounded-md bg-black">
          <p className="h-[5px] rounded-xl bg-primary md:w-[50%] w-[70%]"></p>
        </div>        <p className="text-sm sm:text-base text-gray-600 max-w-2xl mx-auto">
        We have experience developing software for various industries, including:
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-[800px] mx-auto">
        {industries.map((industry, index) => (
          <div key={index} className="border-2 border-dashed border-blue-400    bg-white rounded-xl shadow-sm p-6 flex  items-center  justify-center gap-3">
            <img src={industry.icon} alt={industry.name} className="w-12 h-12 object-contain" />
            <p className="text-lg font-semibold text-gray-800">{industry.name}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
